export default {
      id: "heart-filled-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#heart-filled-usage",
      toString: function () {
        return this.url;
      }
    }